import { useCallback } from "react"

import { WEBBACK_V2_API } from "@constants"
import { useToast } from "@hooks"
import { adminScrapingDataReviewFiltersSubmitted } from "../@signals"


export default function useAdminScrapingDataReviewExcel() {
    const { showToast } = useToast()

    const handleExcel = useCallback(() => {
        const customerID = adminScrapingDataReviewFiltersSubmitted.value.customerID
        const retailer = adminScrapingDataReviewFiltersSubmitted.value.retailer
        const singleDate = adminScrapingDataReviewFiltersSubmitted.value.singleDate

        return showToast.promiseGetExcelWithoutFilters(
            `${WEBBACK_V2_API}/admin/scraping-data-review/raw-data/${customerID}/${retailer}/${singleDate}/excel`, null, {
                onError: data => {
                    if (data.toString().includes("Error"))
                        return "Excel file size exceeded"
                }
            }
        )
    }, [JSON.stringify(adminScrapingDataReviewFiltersSubmitted.value)])

    return { handleExcel }
}